import {
  Egg, EggFried, Drumstick, Beef, Fish, Salad, Sandwich, Soup, Pizza, Milk, Coffee,
  GlassWater, Cookie, Donut, Croissant, CakeSlice, Apple, Banana, Carrot, Cherry, Grape,
  Wheat, Bean, Nut, Popcorn, Candy, Utensils,
} from 'lucide-react';

/** Maps a preset's `icon` string key → a lucide component. Keys = FOOD_ICON_KEYS. */
export const FOOD_ICON_MAP: Record<string, React.ElementType> = {
  egg: Egg,
  eggFried: EggFried,
  drumstick: Drumstick,
  beef: Beef,
  fish: Fish,
  salad: Salad,
  sandwich: Sandwich,
  soup: Soup,
  pizza: Pizza,
  milk: Milk,
  coffee: Coffee,
  water: GlassWater,
  cookie: Cookie,
  donut: Donut,
  croissant: Croissant,
  cake: CakeSlice,
  apple: Apple,
  banana: Banana,
  carrot: Carrot,
  cherry: Cherry,
  grape: Grape,
  wheat: Wheat,
  bean: Bean,
  nut: Nut,
  popcorn: Popcorn,
  candy: Candy,
  utensils: Utensils,
};

export function foodIcon(key: string): React.ElementType {
  return FOOD_ICON_MAP[key] ?? Utensils;
}
